import React from 'react';
import { FormField } from '../../components/FormField';

interface HouseCriteriaProps {
  formData: any;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const HouseCriteria: React.FC<HouseCriteriaProps> = ({
  formData,
  handleInputChange,
}) => {
  const criteria = [
    { name: 'hasAirConditioning', label: 'Climatisation' },
    { name: 'hasTerrace', label: 'Terrasse' },
    { name: 'hasBalcony', label: 'Balcon' },
    { name: 'hasSeaView', label: 'Vue Mer' },
    { name: 'hasClearView', label: 'Vue dégagée' },
    { name: 'hasPool', label: 'Piscine' },
    { name: 'hasParking', label: 'Parking' },
    { name: 'hasGarage', label: 'Garage' },
    { name: 'hasCistern', label: 'Citerne' },
    { name: 'hasWaterTank', label: 'Bâche à eau' },
    { name: 'hasDoubleGlazing', label: 'Double Vitrage' },
    { name: 'hasElevator', label: 'Ascenseur' },
    { name: 'isRecentlyRenovated', label: 'Maison rénovée récemment' },
    { name: 'hasRoofTerrace', label: 'Terrasse sur le toit' },
    { name: 'hasGasHeating', label: 'Chauffage au gaz' },
    { name: 'hasElectricShutters', label: 'Volets électriques' },
    { name: 'hasGuardian', label: 'Gardien' },
    { name: 'hasShopsNearby', label: 'Proximité commerces' },
    { name: 'hasSchoolsNearby', label: 'Proximité école' },
    { name: 'hasElectricGate', label: 'Portail électrique' },
  ];

  return (
    <FormField label="Critères">
      <div className="grid grid-cols-2 gap-4">
        {criteria.map(({ name, label }) => (
          <label key={name} className="flex items-center gap-2">
            <input
              type="checkbox"
              name={name}
              checked={formData[name] || false}
              onChange={handleInputChange}
            />
            <span>{label}</span>
          </label>
        ))}
      </div>
    </FormField>
  );
};